import { SalesforceServiceWindtalkProxy } from './salesforceLightning.proxy.model';
import { link } from './windtalk';

window.salesforceService = window.salesforceService || link(window.parent);
export const salesforceService: SalesforceServiceWindtalkProxy = window.salesforceService;
